import { ref, computed, onMounted, onUnmounted } from 'vue'
import { debounce } from 'throttle-debounce'

const DEFAULT_BREAKPOINTS = {
  MOBILE: 480,
  TABLET: 768,
  DESKTOP: 880,
}

export function useWindowResizeObserver() {
  const windowWidth = ref<number>(window.innerWidth)

  const isOnDesktop = computed(
    () => windowWidth.value > DEFAULT_BREAKPOINTS.DESKTOP,
  )

  const updateWindowWidth = () => {
    windowWidth.value = window.innerWidth
  }

  const handleResize = debounce(300, updateWindowWidth)

  onMounted(() => {
    window.addEventListener('resize', handleResize)
    updateWindowWidth()
  })

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
  })

  return {
    isOnDesktop,
  }
}
